// extracted by mini-css-extract-plugin
export default {"control":"ZFxK1Chz9j","active":"ws71deIpu1","dark":"lt68SjcDPE"};